import { SidebarNav } from './SidebarNav';
import { useGlobalInboxBadge } from '@/hooks/messaging/useGlobalInboxBadge';

/**
 * Desktop sidebar — a single labeled accordion column (replaces the old icon
 * rail + secondary panel double-panel). Hidden on mobile (MobileBottomBar).
 */
export function Sidebar() {
  // Mount the global unread-badge sync. Lives here (vs in InboxPage) so the
  // Inbox count stays accurate on every dashboard route — not only while on
  // /dashboard/inbox.
  useGlobalInboxBadge();

  return (
    <aside className="hidden h-full shrink-0 md:flex">
      <SidebarNav />
    </aside>
  );
}
